// MyContext.tsx
import React, {createContext, useContext, useState, ReactNode} from 'react'

type MyContextType = {
  page: string
  setPage: (val: string) => void
}

const MyContext = createContext<MyContextType | undefined>(undefined)

export const PageProvider = ({children}: {children: ReactNode}) => {
  const [page, setPage] = useState('')

  return <MyContext.Provider value={{page, setPage}}>{children}</MyContext.Provider>
}

// Custom hook for easy usage
export const usePageContext = () => {
  const ctx = useContext(MyContext)
  if (!ctx) throw new Error('usePageContext must be used inside MyProvider')
  return ctx
}
